/* Stylized geometric fox motif (decorative SVG). */
export const FoxMotif = ({ className = "", size = 220, withGlow = false, testId = "fox-motif" }) => {
  return (
    <div
      data-testid={testId}
      className={`pointer-events-none select-none ${className}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {withGlow && (
        <div className="absolute inset-0 pf-hero-blob blur-2xl" />
      )}
      <svg
        viewBox="0 0 200 200"
        width="100%"
        height="100%"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Left ear */}
        <path
          d="M30 30 L72 18 L70 78 Z"
          fill="#F35A1F"
          stroke="#121316"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        {/* Right ear */}
        <path
          d="M170 30 L128 18 L130 78 Z"
          fill="#F35A1F"
          stroke="#121316"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        {/* Inner left ear */}
        <path
          d="M50 36 L70 30 L68 64 Z"
          fill="#FBFAF8"
        />
        {/* Inner right ear */}
        <path
          d="M150 36 L130 30 L132 64 Z"
          fill="#FBFAF8"
        />
        {/* Face base (diamond) */}
        <path
          d="M100 50 L160 70 L100 180 L40 70 Z"
          fill="#F35A1F"
          stroke="#121316"
          strokeWidth="4"
          strokeLinejoin="round"
        />
        {/* White face mask */}
        <path
          d="M100 96 L132 110 L100 170 L68 110 Z"
          fill="#FBFAF8"
          stroke="#121316"
          strokeWidth="3"
          strokeLinejoin="round"
        />
        {/* Eyes */}
        <circle cx="76" cy="96" r="6" fill="#121316" />
        <circle cx="124" cy="96" r="6" fill="#121316" />
        {/* Eye sparkle */}
        <circle cx="78" cy="94" r="1.6" fill="#FBFAF8" />
        <circle cx="126" cy="94" r="1.6" fill="#FBFAF8" />
        {/* Nose */}
        <path
          d="M94 120 L106 120 L100 130 Z"
          fill="#121316"
        />
        {/* Whisker hints */}
        <path d="M70 120 L86 122" stroke="#121316" strokeWidth="2" strokeLinecap="round" />
        <path d="M114 122 L130 120" stroke="#121316" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
};

export default FoxMotif;
